// extracted by mini-css-extract-plugin
export default {"hightLightMain":"bottomComponent_hightLightMain__jzOXz"};